'use client';
import { useEffect } from 'react';
import { useHasHoverSupport } from '@THC/hooks';
import { useConstantCallback } from './useConstantCallback';
export const useFocusWithin = (ref, handler) => {
    const constantHandler = useConstantCallback(handler);
    const hasHoverSupport = useHasHoverSupport();
    useEffect(() => {
        if (!hasHoverSupport) {
            return undefined;
        }
        const refElement = ref.current;
        if (!refElement) {
            return undefined;
        }
        const onFocus = (event) => constantHandler({ event, hasFocus: true });
        const onBlur = (event) => constantHandler({ event, hasFocus: false });
        refElement.addEventListener('focusin', onFocus, { passive: true });
        refElement.addEventListener('focusout', onBlur, { passive: true });
        return () => {
            refElement.removeEventListener('focusin', onFocus);
            refElement.removeEventListener('focusout', onBlur);
        };
    }, [constantHandler, hasHoverSupport, ref]);
};
